import React from "react";
import ReactDOM from "react-dom";
import $ from "jquery";

function javascript(next_code) {
  $(document).ready(function ($) {
    $(document).ready(function () {
      var enterCode = "";
      enterCode.toString();

      $("#l_numbers button").click(function () {
        var clickedNumber = $(this).text().toString();
        enterCode = enterCode + clickedNumber;
        var lengthCode = parseInt(enterCode.length);
        lengthCode--;
        $("#l_fields .l_numberfield:eq(" + lengthCode + ")").addClass("active");

        if (lengthCode == 4) {
          // Check the PIN
          if (enterCode == "ROCKY" || enterCode == "LABO#") {
            // Right PIN!
            window.location.href = next_code;
          } else {
            // Wrong PIN!
            $("#l_fields").addClass("miss");
            enterCode = "";
            setTimeout(function () {
              $("#l_fields .l_numberfield").removeClass("active");
            }, 200);
            setTimeout(function () {
              $("#l_fields").removeClass("miss");
            }, 500);
          }
        } else {
        }
      });

      $("#restartbtn").click(function () {
        enterCode = "";
        $("#l_fields .l_numberfield").removeClass("active");
        $("#l_fields .l_numberfield").removeClass("right");
        $("#l_numbers").removeClass("hide");
      });
    });
  });
}

export default javascript;
